module.exports = __webpack_public_path__ + "static/Margaux_Olivre-46a14ba9335ce95bfc4d2f3ba5cf77f1.webp";